import React from 'react';
import { Link } from 'react-router-dom';

const SenasTable = ({ senas, selectedItems, handleCheckboxChange, formatTime }) => (
  <>
    <h3 className="text-2xl font-extrabold text-amber-400 mt-10 mb-6 tracking-tight">
      Señas de Hoy
    </h3>

    {senas.length > 0 ? (
      <div className="overflow-x-auto border border-gray-700 rounded-xl shadow-xl mb-10 bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800">
        <table className="min-w-full text-sm text-left text-gray-100">
          <thead className="text-xs uppercase bg-gray-900 text-gray-400 sticky top-0 z-10">
            <tr>
              <th className="px-6 py-4 font-semibold tracking-wide">Seleccionar</th>
              <th className="px-6 py-4 font-semibold tracking-wide">Servicio</th>
              <th className="px-6 py-4 font-semibold tracking-wide">Cliente</th>
              <th className="px-6 py-4 font-semibold tracking-wide">Monto</th>
              <th className="px-6 py-4 font-semibold tracking-wide">Método Pago</th>
              <th className="px-6 py-4 font-semibold tracking-wide">Usuario</th>
              <th className="px-6 py-4 font-semibold tracking-wide">Hora</th>
            </tr>
          </thead>
          <tbody>
            {senas.map((sn, idx) => {
              const isSelected = selectedItems.has(sn.sena_id);
              return (
                <tr
                  key={sn.sena_id}
                  className={`transition-all duration-300 ease-in-out ${
                    idx % 2 === 0 ? 'bg-gray-800' : 'bg-gray-700'
                  } hover:bg-gray-600`}
                >
                  <td className="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleCheckboxChange(sn.sena_id)}
                      className="h-5 w-5 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500 focus:ring-2"
                    />
                  </td>
                  <td className="px-6 py-4 font-medium">{sn.servicio_nombre || 'N/A'}</td>
                  <td className="px-6 py-4">
                    {sn.cliente_id ? (
                      <Link
                        to={`/detalles/cliente/${sn.cliente_id}`}
                        className="font-semibold text-amber-300 hover:text-amber-500 transition-colors"
                      >
                        {sn.cliente_nombre} {sn.cliente_apellido}
                      </Link>
                    ) : (
                      <span className="italic text-gray-400">Cliente no registrado</span>
                    )}
                  </td>
                  <td className="px-6 py-4 font-bold text-amber-400">
                    ${sn.monto.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-block bg-amber-600 bg-opacity-80 text-white px-3 py-1 text-xs font-semibold rounded-full shadow-sm">
                      {sn.metodo_pago}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-block bg-gray-300 text-gray-900 px-3 py-1 text-xs font-semibold rounded-full">
                      {sn.usuario_sena || 'N/A'}
                    </span>
                  </td>
                  <td className="px-6 py-4">{formatTime(sn.hora)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="text-gray-400 italic mb-10 flex items-center space-x-2">
        <i className="fas fa-info-circle text-amber-500"></i>
        <span>No hay señas registradas hoy.</span>
      </div>
    )}
  </>
);

export default SenasTable;
